import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.ends-with.js";
export default {
  name: "UploadFile",
  model: {
    prop: 'url',
    event: 'input'
  },
  props: {
    url: {
      type: String,
      default: ""
    },
    accept: {
      type: String,
      default: ".pdf"
    },
    limit: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      uploading: false,
      fileList: []
    };
  },
  watch: {
    url: {
      immediate: true,
      handler: function handler(val) {
        this.fileList = val ? [val] : [];
      }
    }
  },
  computed: {
    action: function action() {
      return "/api/v3/admin/bank/uploadFile";
    }
  },
  methods: {
    beforeUpload: function beforeUpload(file) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(_this.accept && !file.name.toLowerCase().endsWith(".pdf"))) {
                _context.n = 1;
                break;
              }
              _this.$message.error("仅支持上传 PDF 文件");
              return _context.a(2, false);
            case 1:
              return _context.a(2, true);
          }
        }, _callee);
      }))();
    },
    doUpload: function doUpload(_ref) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var file, onSuccess, onError, formData, res, url, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              file = _ref.file, onSuccess = _ref.onSuccess, onError = _ref.onError;
              _context2.p = 1;
              _this2.uploading = true;
              formData = new FormData();
              formData.append("file", file);
              formData.append("multimediaType", "wellceeContracts");
              _context2.n = 2;
              return _this2.$api.bankUploadInvoice(formData);
            case 2:
              res = _context2.v;
              url = res.data || "";
              if (url) {
                _context2.n = 3;
                break;
              }
              throw new Error("上传失败：未返回URL");
            case 3:
              _this2.fileList = [url];
              _this2.$emit("input", url);
              _this2.$emit("update:url", url);
              onSuccess && onSuccess(res);
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t = _context2.v;
              console.error(_t);
            case 5:
              _context2.p = 5;
              _this2.uploading = false;
              return _context2.f(5);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 4, 5, 6]]);
      }))();
    },
    previewFile: function previewFile(url) {
      if (!this.url) return;
      window.open(this.url, "_blank");
    },
    handleRemove: function handleRemove(index) {
      this.fileList.splice(index, 1);
      var url = this.fileList[0] || "";
      this.$emit("input", url);
      this.$emit("update:url", url);
    }
  }
};